import { Injectable, inject } from '@angular/core';
import { CrudService } from '@shared/modules/crud/crud.service';
import { MODEL, Parametry } from './parametry.config';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ParametryService {
    model = MODEL;

    crudService = inject(CrudService);

    getOne(id: string): Observable<Partial<Parametry>> {
        this.crudService.setModel(`${this.model}`);
        return this.crudService.findFirst<Partial<Parametry>>(id);
    }

    update(id: string, parametry: Partial<Parametry>) {
        const path = this.model;
        this.crudService.setModel(path);
        return this.crudService.update(id, parametry);
    }
}
